"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = BannerErrors;
const react_1 = __importDefault(require("react"));
const BannerErrors_module_scss_1 = __importDefault(require("./BannerErrors.module.scss"));
function BannerErrors({ errors }) {
    return (react_1.default.createElement("div", { "data-testid": "banner-errors", className: BannerErrors_module_scss_1.default.bannerErrorsContainer },
        react_1.default.createElement("p", { className: BannerErrors_module_scss_1.default.title },
            "Banner not showing due to ",
            errors.length,
            " error",
            errors.length > 1 ? "s" : "",
            ":"),
        react_1.default.createElement("ul", null, errors.map((error, index) => (react_1.default.createElement("li", { key: index, className: BannerErrors_module_scss_1.default.error }, error)))),
        react_1.default.createElement("p", { className: BannerErrors_module_scss_1.default.note }, "NB: these issues need to be resolved before you can preview the banner")));
}
